import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/base.css'
import myconf from './lib/config.js'

Vue.config.productionTip = false



// vue全局变量
Vue.prototype.myconf = myconf

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
